import React, { useState } from 'react';

const QRScanner = ({ onScanSuccess, onScanError }) => {
  const [isScanning, setIsScanning] = useState(false);
  const [error, setError] = useState(null);
  const [manualInput, setManualInput] = useState('');
  const [showManualInput, setShowManualInput] = useState(false);

  const startScanning = async () => {
    if (!window.Telegram?.WebApp) {
      setError('Приложение должно быть запущено в Telegram');
      return;
    }

    try {
      setIsScanning(true);
      setError(null);

      // Проверяем, поддерживается ли showScanQrPopup
      if (typeof window.Telegram.WebApp.showScanQrPopup === 'function') {
        // Используем Telegram WebApp API для сканирования QR
        window.Telegram.WebApp.showScanQrPopup({
          text: 'Наведите камеру на QR код приза',
        }, (result) => {
          if (result) {
            // При успешном сканировании закрываем сканер и передаем результат
            setIsScanning(false);
            onScanSuccess(result);
          } else {
            // При отмене сканирования
            setIsScanning(false);
            onScanError('Сканирование отменено');
          }
        });
      } else {
        // Fallback: показываем ручной ввод
        setShowManualInput(true);
        setIsScanning(false);
      }

    } catch (error) {
      console.error('QR scanning error:', error);
      // Fallback: показываем ручной ввод
      setShowManualInput(true);
      setIsScanning(false);
    }
  };

  const handleManualSubmit = (e) => {
    e.preventDefault();
    if (manualInput.trim()) {
      onScanSuccess(manualInput.trim().toUpperCase());
      setManualInput('');
      setShowManualInput(false);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-4">
      {!showManualInput ? (
        <>
          <button
            onClick={startScanning}
            disabled={isScanning}
            className={`
              tg-button
              ${isScanning ? 'opacity-50 cursor-not-allowed' : ''}
            `}
          >
            {isScanning ? (
              <div className="flex items-center space-x-2">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
                <span>Сканирование...</span>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V6a1 1 0 00-1-1H5a1 1 0 00-1 1v1a1 1 0 001 1zm12 0h2a1 1 0 001-1V6a1 1 0 00-1-1h-2a1 1 0 00-1 1v1a1 1 0 001 1zM5 20h2a1 1 0 001-1v-1a1 1 0 00-1-1H5a1 1 0 00-1 1v1a1 1 0 001 1z" />
                </svg>
                <span>Сканировать QR</span>
              </div>
            )}
          </button>

          <button
            onClick={() => setShowManualInput(true)}
            className="tg-button-secondary"
          >
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              <span>Ввести вручную</span>
            </div>
          </button>
        </>
      ) : (
        <div className="w-full space-y-4">
          <form onSubmit={handleManualSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium tg-text-primary mb-2">
                Введите код приза
              </label>
              <input
                type="text"
                value={manualInput}
                onChange={(e) => setManualInput(e.target.value)}
                placeholder="QTZ54KW5 или P-AB12CD34-E5"
                className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                autoFocus
              />
            </div>
            <div className="flex space-x-3">
              <button
                type="submit"
                className="flex-1 tg-button"
                disabled={!manualInput.trim()}
              >
                Отправить
              </button>
              <button
                type="button"
                onClick={() => setShowManualInput(false)}
                className="flex-1 tg-button-secondary"
              >
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      {error && (
        <div className="tg-text-secondary text-sm text-center tg-card border-red-500 border-2">
          {error}
        </div>
      )}

      <div className="tg-text-secondary text-sm text-center max-w-md">
        <p className="mb-2">Нажмите кнопку, чтобы открыть сканер QR кодов и отсканировать приз</p>
        <p className="text-xs opacity-75">Ожидается формат: P-XXXXXXXX-XX</p>
        <p className="text-xs opacity-50 mt-1">Пример: P-AB12CD34-E5</p>
      </div>
    </div>
  );
};

export default QRScanner; 